export default function completeAccountRegistration({ next, store }) {
  if (store.getters['auth/getUserType']) {
    return next({ name: 'misc-not-authorized' })
  }

  return next();
}
